module.exports = __webpack_public_path__ + "img/my_head_bg.5b873223.png";